import { Card, CardContent, Stack, Typography } from '@mui/material'
import React from 'react'

import { getBackgroundColorFromReliabilityScore } from 'components/reliability-management/company-dashboard/rm-company-dashboard-utils'
import { formatOwnerDetails } from 'components/services/service-utils'
import { GroupedServicesResponse } from 'types/api/policies/reliability-report'

export const DashboardTeamGroupListCard: React.FC<{
  serviceGroup: GroupedServicesResponse
}> = ({ serviceGroup }) => {
  const { avgScore, numOfServices, groupDetails } = serviceGroup
  const { name, ownerDetails } = groupDetails
  const { identifier, firstName, lastName } = ownerDetails

  return (
    <Card
      data-test-company-dashboard-team-group-list-card
      sx={(muiTheme) => ({
        backgroundColor: getBackgroundColorFromReliabilityScore(
          muiTheme,
          avgScore
        )
      })}
    >
      <CardContent
        sx={{
          alignItems: 'center',
          display: 'flex',
          paddingRight: 8
        }}
      >
        <Stack flexGrow={2}>
          <Stack alignItems="baseline" direction="row" display="flex" gap={2}>
            <Typography data-test-team-name mb={1} variant="h6">
              {name}
            </Typography>
          </Stack>
          <Typography data-test-team-information>
            {formatOwnerDetails(identifier, firstName, lastName)}
          </Typography>
        </Stack>
        <Stack direction="row" flexGrow={1} gap={5} justifyContent="flex-end">
          <Stack>
            <Typography data-test-number-of-services margin="auto" variant="h4">
              {numOfServices}
            </Typography>
            <Typography variant="body1">Services</Typography>
          </Stack>
          <Stack>
            <Typography data-test-average-score margin="auto" variant="h4">
              {avgScore}
            </Typography>
            <Typography variant="body1">Average Score</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}
